import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { useEmojiPickerContext } from '../context/EmojiPickerContext';
export const EmojiSelection = () => {
    const { emojiSelectionLabel, previewEmoji } = useEmojiPickerContext();
    return (_jsx(Wrapper, { p: 4, children: previewEmoji ? (_jsx(EmojiSelectionPreview, { emoji: previewEmoji })) : (_jsx(Box, { alignItems: "center", font: "body-regular-asphalt", height: "32px", children: emojiSelectionLabel })) }));
};
const EmojiSelectionPreview = ({ emoji }) => (_jsx(Box, { alignItems: "center", children: _jsx(EmojiIcon, { children: emoji.emoji }) }));
const EmojiIcon = styled(Box).attrs(() => ({
    alignItems: 'center',
    fontSize: 23,
    height: 32,
    justifyContent: 'center',
    minWidth: 32,
})) ``;
const Wrapper = styled(Box) `
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
`;
//# sourceMappingURL=EmojiSelection.js.map